import {
    GET_PATIENT_DETAILS_REQUEST, GET_PATIENT_DETAILS_SUCCESS, GET_PATIENT_DETAILS_FAILURE
} from './constants';

const initialState = {
    loading: true,
    adminPatientDetails: undefined,
};


const adminPatientDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PATIENT_DETAILS_REQUEST: {
            return Object.assign({}, state, {loading: false, adminPatientDetails: undefined});
        }
        case GET_PATIENT_DETAILS_SUCCESS: {
            return Object.assign({}, state, {loading: false, adminPatientDetails: action.data.patientDetails});
        }
        case GET_PATIENT_DETAILS_FAILURE: {
            return Object.assign({}, state, {loading: false, error: action.data.errors});
        }
        default: {
            return state;
        }
    }
};

export default adminPatientDetailsReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/PatientDetails/reducer.js